import React from "react";

import { Button, ButtonBsStyle } from "@common/components/Button";
import { Flex } from "@common/components/Flex";
import { Header } from "@common/components/Header";
import { getTestAttributes } from "@common/utils/tests";
import { trDts } from "@modules/datasheets/utils/i18n";
import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";

import { DatasheetFormatManagement } from "../datasheet-format-management";
import { DatasheetFormatManagementMode } from "../datasheet-format-management/datasheet-format-management.types";

export type HomeProps = {};

export const Home: React.FC<HomeProps> = () => {
  const [datasheetFormatManagementMode, setDatasheetFormatManagementMode] = React.useState<
    DatasheetFormatManagementMode | undefined
  >();

  const closeDatasheetFormatManagementMode = React.useCallback(() => {
    setDatasheetFormatManagementMode(undefined);
  }, []);

  const handleDatasheetFormatManagementSubmit = React.useCallback(() => {
    closeDatasheetFormatManagementMode();
  }, [closeDatasheetFormatManagementMode]);

  const headerActions: Array<{
    id: string;
    label: string;
    onClick: () => void;
    btnType?: ButtonBsStyle;
    disabled?: boolean;
  }> = [
    {
      id: getTestAttributes({ id: "data-sheet-formats-wnd-btn-Export Format" }).id,
      label: trDts("Export Format"),
      onClick: () => setDatasheetFormatManagementMode(DatasheetFormatManagementMode.export),
    },
    {
      id: getTestAttributes({ id: "data-sheet-formats-wnd-btn-Import Datasheet" }).id,
      label: trDts("Import Format"),
      onClick: () => {
        //
      },
    },
    {
      id: getTestAttributes({ id: "data-sheet-formats-wnd-btn-Load Datasheet" }).id,
      label: trDts("Load Datasheet"),
      btnType: "primary",
      onClick: () => setDatasheetFormatManagementMode(DatasheetFormatManagementMode.load),
    },
    {
      id: getTestAttributes({ id: "data-sheet-formats-wnd-btn-New Datasheet" }).id,
      label: trDts("New Datasheet"),
      btnType: "primary",
      onClick: () => setDatasheetFormatManagementMode(DatasheetFormatManagementMode.new),
    },
  ];

  return (
    <div>
      <Header moduleName={trDts("Datasheets")}>
        <Flex width="100%" justify="flex-end">
          {headerActions.map((x) => (
            <Button
              style={{ marginLeft: "10px" }}
              key={x.id}
              text={x.label}
              bsStyle={x.btnType}
              id={x.id}
              data-id={x.id}
              disabled={x.disabled}
              onClick={x.onClick}
            />
          ))}
        </Flex>
      </Header>
      {datasheetFormatManagementMode && (
        <DatasheetFormatManagement
          onClose={closeDatasheetFormatManagementMode}
          getId={{
            title: getTestAttributes({ id: "load-fm-format-header" }).id,
            folderChooserBtn: getTestAttributes({ id: "fp-new-data-sheet-wnd-folder-picker" }).id,
            formatTypes: getTestAttributes({ id: "new-data-sheet-wnd-format-type-drop-btn" }).id,
            selectedFolderNameHolder: getTestAttributes({ id: "tx-new-data-sheet-wnd-folder" }).id,
            formatName: getTestAttributes({ id: "tx-new-data-sheet-wnd-ds-format-name" }).id,
          }}
          onSubmit={handleDatasheetFormatManagementSubmit}
          getFormats={() =>
            Promise.resolve([
              {
                id: 1,
                name: "test format",
              },
            ])
          }
          getFolders={() =>
            Promise.resolve([
              {
                id: 1,
                name: "test folder",
                parentid: 0,
              },
            ] as Array<FolderPrimaryListDto>)
          }
          mode={datasheetFormatManagementMode}
          checkFormatNameExists={() => Promise.resolve(false)}
        />
      )}
    </div>
  );
};
